import { Route, Routes } from 'react-router-dom';
import { SignIn } from './sign-in/sign-in';

export const UserRoutes = () => {
  return (
    <Routes>
      <Route path="sign-in" element={<SignIn />} />
    </Routes>
  );
};
